// "🔗 Paired with" — the automations that switch THIS button, shown on the light
// itself (ButtonSettingsDialog, both shells), so a lamp that comes on by itself
// says why: "When 🚪 Bedroom door Open · 19:00–00:00 · if off → Night Lamp ON".
//
// Read from GetAutomationsForDevice (Home Automation api/new/automations.js).
// Renders nothing when the server has no automations yet — a light's settings
// must not show a broken section.

import React, { useCallback, useEffect, useState } from 'react';
import {
  Box, Typography, Button, Divider,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { getAutomationsForDevice } from '../../core/api/api';
import { describeAutomation } from '../../core/automations/automationText';
import AutomationsDialog from './AutomationsDialog';

export default function PairedAutomations({ uniqueNumber, output, locationId }) {
  const [rules, setRules] = useState(null);   // null = not available
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    if (!uniqueNumber) return;
    getAutomationsForDevice(uniqueNumber)
      .then((r) => setRules(r?.data?.ok ? (r.data.automations || []) : null))
      .catch(() => setRules(null));
  }, [uniqueNumber]);
  useEffect(() => { load(); }, [load]);

  if (rules == null) return null;
  const mine = rules.filter((r) => (r.Actions || []).some((a) => String(a.UniqueNumber) === String(uniqueNumber)
    && Number(a.Output) === Number(output)));
  const ctx = { sensors: mine.map((r) => r.Trigger).filter(Boolean), messageDevices: [] };

  return (
    <Box sx={{ mt: 1.5 }}>
      <Divider sx={{ mb: 1 }}>
        <Typography variant="caption" color="text.secondary">🔗 Paired with</Typography>
      </Divider>
      {!mine.length && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          No sensor switches this button.
        </Typography>
      )}
      {mine.map((r) => (
        <Typography key={r.AutomationId} variant="body2" className="fit-text"
          color={Number(r.Enabled) ? 'text.primary' : 'text.secondary'} sx={{ mb: 0.5 }}>
          {`${Number(r.Enabled) ? '' : '(off) '}${describeAutomation(r, ctx)}`}
        </Typography>
      ))}
      <Button size="small" startIcon={<LinkIcon />} onClick={() => setOpen(true)} disabled={!locationId}>
        {mine.length ? 'Manage' : 'Pair with a sensor…'}
      </Button>
      <AutomationsDialog
        open={open}
        onClose={() => { setOpen(false); load(); }}
        locationId={locationId}
        forTarget={{ uniqueNumber, output }}
      />
    </Box>
  );
}
